module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("btqmo"))).then(() => parcelRequire('2MjXz'));